/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendBusinessAngelDto } from '../../models/backend-business-angel-dto';
import { BackendBusinessAngelRequestDto } from '../../models/backend-business-angel-request-dto';

export interface VentureFundsBusinessAngelsUpdate$FormData$Params {
  id: number;
  body: BackendBusinessAngelRequestDto;
}

export function ventureFundsBusinessAngelsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsBusinessAngelsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendBusinessAngelDto>;
    }),
  );
}

ventureFundsBusinessAngelsUpdate$FormData.PATH = '/api/venture_funds/business-angels/{id}/';
